import { Injectable, inject } from '@angular/core';

import { DialogCloseResult } from '@progress/kendo-angular-dialog';

import { NotificationTypeEnum } from '@nexweb/shared/data-access/mdd';
import { BaseSignalR, SignalRHubNames } from '@nexweb/shared/signalr-helper';

import { BmDialogService } from '../services/bm-dialog.service';

@Injectable({
  providedIn: 'root',
})
export class BmSystemMessagingHubService extends BaseSignalR {
  private bmDialogService = inject(BmDialogService);

  constructor() {
    super(SignalRHubNames.systemMessaging);
  }

  protected initEvents(): void {
    this.hubConnection.on(
      'NotifyUser',
      (
        messageId: number,
        messageText: string,
        notificationComponent: NotificationTypeEnum,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        parameters: { ErrorMessage: string; BidId: number },
      ) => {
        switch (notificationComponent) {
          case NotificationTypeEnum.requestingTsoConfirmation:
            this.bmDialogService.showRequestingTsoConfirmationDialog(parameters.BidId);
            break;
          case NotificationTypeEnum.supplyingTsoNotification:
            this.bmDialogService.showSupplyingTsoNotificationDialog(parameters.BidId).subscribe((result) => {
              if (
                !(result instanceof DialogCloseResult) &&
                !(result.text === this.bmDialogService.getSupplyingTsoSubmitButtonText())
              ) {
                this.bmDialogService.showTsoResponseToActivationRequestDialog(parameters.BidId);
              }
            });
            break;
          case NotificationTypeEnum.supplyingBspNotification:
            this.bmDialogService.showSupplyingBspNotificationDialog(parameters.BidId);
            break;
          case NotificationTypeEnum.acceptanceOfActivationRequest:
            this.bmDialogService.showAcceptanceOfActivationRequestNotificationDialog(parameters.BidId);
            break;
          case NotificationTypeEnum.declinationOfActivationRequest:
            this.bmDialogService.showDeclinationOfActivationRequestNotificationDialog(parameters.BidId);
            break;
          case NotificationTypeEnum.deactivationInstructingTsoConfirmation:
            this.bmDialogService.showDeactivationInstructingTsoConfirmationDialog(parameters.BidId);
            break;
          case NotificationTypeEnum.deactivationSupplyingTsoNotification:
            this.bmDialogService.showDeactivationSupplyingTsoNotificationDialog(parameters.BidId);
            break;
          case NotificationTypeEnum.deactivationSupplyingBspNotification:
            this.bmDialogService.showDeactivationSupplyingBspNotificationDialog(parameters.BidId);
            break;
          case NotificationTypeEnum.requestingTsoConfirmationOfExtension:
            this.bmDialogService.showExtensionRequestingTsoConfirmationDialog(parameters.BidId);
            break;
          case NotificationTypeEnum.supplyingTsoNotificationOfExtension:
            this.bmDialogService.showExtensionSupplyingTsoNotificationDialog(parameters.BidId).subscribe((result) => {
              if (
                !(result instanceof DialogCloseResult) &&
                !(result.text === this.bmDialogService.getSubmitButtonText())
              ) {
                this.bmDialogService.showTsoResponseToExtensionRequestDialog(parameters.BidId);
              }
            });
            break;
          case NotificationTypeEnum.supplyingBspNotificationOfExtension:
            this.bmDialogService.showExtensionSupplyingBspNotificationDialog(parameters.BidId);
            break;
          default:
            break;
        }
      },
    );
  }
}
